"use client";

import React from "react";
import {Box, SxProps, Theme, useTheme} from "@mui/material";

type ZoomingImageProps = React.ComponentProps<"img"> & {
  sx?: SxProps<Theme>;
};

export default function ZoomingImage({sx, ...props}: ZoomingImageProps) {
  const theme = useTheme();

  return (
      <Box sx={{overflow: "hidden", borderRadius: 4, ...sx}}>
        <Box
            component="img"
            {...props}
            sx={{
              width: "100%",
              height: "auto",
              display: "block",
              transition: theme.transitions.create("transform", {
                duration: 1200,
                easing: "ease",
              }),
              "&:hover": {
                transform: "scale(1.2)",
              },
            }}
            fetchPriority="high"
        />
      </Box>
  );
}
